interface VisitedCategory {
  id: string;
  name: string;
  image_url: string;
  visitedAt: number;
}

export const categoryHistory = {
  add: (category: { id: string; name: string; image_url: string }) => {
    const visited = localStorage.getItem('visitedCategories');
    const visitedCategories: VisitedCategory[] = visited ? JSON.parse(visited) : [];
    
    // Remover la categoría si ya existe
    const filtered = visitedCategories.filter(c => c.id !== category.id);
    
    // Agregar la categoría al principio del array
    filtered.unshift({
      ...category,
      visitedAt: Date.now()
    });
    
    // Mantener solo las últimas 10 categorías (aumentado de 5 a 10)
    const latest = filtered.slice(0, 10);
    
    localStorage.setItem('visitedCategories', JSON.stringify(latest));
  },
  
  get: (): VisitedCategory[] => {
    const visited = localStorage.getItem('visitedCategories');
    return visited ? JSON.parse(visited) : [];
  }
};